var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('v-icon',[_vm._v("mdi-microphone")]),_vm._l((10),function(n){return _c('v-icon',{key:n,attrs:{"color":"primary"}},[_vm._v(" "+_vm._s(_vm.level > n ? 'mdi-circle' : 'mdi-circle-outline')+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }